<template>
    <v-overlay
        :value="alert.show"
        z-index="9999999"
    >
        <v-card
            :color="alert.type"
            class="elevation-3 pa-2"
            @click="setAlert({ show: false, type: '', message: '' })"
        >
            <v-card-text>
                <v-icon left>mdi-message-text</v-icon>
                <span id="message">{{ alert.message }}</span>
            </v-card-text>
            <v-card-actions>
                <v-row
                    justify="center"
                >
                    <v-btn
                        color="white"
                        tile
                        small
                        depressed
                        @click="setAlert({ show: false, type: '', message: '' })"
                    >
                        <v-icon left color="black">mdi-close</v-icon>
                        <span class="black--text">Fechar</span>
                    </v-btn>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-overlay>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'Alerta',

    computed: {
        ...mapGetters('utils', { alert: 'getAlert' }),
    },

    methods: {
        ...mapActions('utils', ['setAlert'])
    }
}
</script>

<style lang="scss" scoped>
    #message {
        font-size: 12pt;
        color: #fff;
    }
</style>
